import { Select, SelectProps } from '@components/select';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormSelectProps<T = unknown> = FormFieldProps<SelectProps, T>;

type Props<T = unknown> =
  | (Omit<FormSelectProps<T>, 'onChange' | 'onSelectionChange'> & {
      selection: 'full';
      onChange?: FormSelectProps['onSelectionChange'];
    })
  | (Omit<FormSelectProps<T>, 'onSelectionChange'> & {
      selection?: 'value';
    });

export function FormSelect<T>({ onChange, selection = 'value', ...props }: Props<T>) {
  const { onChange: formFieldOnChange, ...formFieldProps } = useFormField({ ...props, onChange });

  if (selection === 'full') {
    return <Select {...props} {...formFieldProps} onSelectionChange={formFieldOnChange} />;
  }

  return <Select {...props} {...formFieldProps} onChange={formFieldOnChange} />;
}
